'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var _objectWithoutProperties = _interopDefault(require('@babel/runtime/helpers/objectWithoutProperties'));
var React = require('react');
var React__default = _interopDefault(React);
var classnames = _interopDefault(require('classnames'));
var PropTypes = _interopDefault(require('prop-types'));
var Box = require('../Box/Box.js');
var _extends = _interopDefault(require('@babel/runtime/helpers/extends'));
var tracked = require('../tracking/tracked.js');
var Button_treat = require('./Button.treat.js');
var MyobButtonStyles = require('../../util/MyobButtonStyles.js');

/**
 * Button
 *
 * @visibleName
 * @see Added: v1.0.0, Last updated: v6.3.0
 * @see since v1.0 Last updated: v6.3.0
 */

var Button = function Button(_ref) {
  var _classnames2;

  var type = _ref.type,
      size = _ref.size,
      children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      icon = _ref.icon,
      iconRight = _ref.iconRight,
      restProps = _objectWithoutProperties(_ref, ["type", "size", "children", "className", "disabled", "icon", "iconRight"]);

  var _getButtonStyle = MyobButtonStyles.default(type, size, disabled),
      buttonClasses = _getButtonStyle.buttonClasses,
      boxProps = _getButtonStyle.boxProps;

  return /*#__PURE__*/React__default.createElement(Box.default, _extends({
    as: "button",
    type: "button",
    disabled: disabled,
    className: classnames(buttonClasses, className)
  }, boxProps, restProps), /*#__PURE__*/React__default.createElement("div", {
    className: classnames('btn__container', Button_treat.container, _defineProperty({}, "".concat(Button_treat.reverse, " btn--reverse"), iconRight))
  }, icon && /*#__PURE__*/React__default.createElement("span", {
    className: classnames('btn__icon', Button_treat.icon.base, (_classnames2 = {}, _defineProperty(_classnames2, Button_treat.icon.left, children && !iconRight), _defineProperty(_classnames2, Button_treat.icon.right, children && iconRight), _classnames2))
  }, icon), children && /*#__PURE__*/React__default.createElement("span", {
    className: classnames('btn__content', Button_treat.content)
  }, children)));
};
Button.defaultProps = {
  type: 'primary',
  size: undefined,
  onClick: function onClick() {},
  disabled: false,
  icon: undefined,
  children: undefined,
  className: undefined,
  iconRight: false,
  'aria-expanded': undefined,
  'aria-label': undefined
};
process.env.NODE_ENV !== "production" ? Button.propTypes = {
  /**
   * Type of button being used.
   *
   * - `primary`: Green main call to action
   *
   * - `secondary`: Grey secondary call to action
   *
   * - `link`: Styled to look like a hyperlink. Not to be used for navigation. Please use an `<a>` tag
   *
   * - `delete`: Red button for destructive call to actions
   *
   * - `clear`: Transparent background style as default, on hover displays gray background, and on active displays gradient background with border
   *
   * @type {String}
   *
   */
  type: PropTypes.oneOf(Button_treat.typeEnum),

  /**
   * String to define the size of the button being used. Effects the padding applied to the button
   *
   * @deprecated size option small
   */
  size: PropTypes.oneOf(['small', 'xs']),

  /**
   * Callback function triggered when the button is clicked. Not fired when its disabled. Called with a `HTML Event`
   */
  onClick: PropTypes.func,

  /**
   * When true adds disabled class to button and cannot be clicked.
   */
  disabled: PropTypes.bool,

  /**
   * One Icon component to be rendered in the button
   * @type {Icon}
   */
  icon: PropTypes.node,

  /**
   * One or many nodes to be inside the button
   */
  children: PropTypes.node,

  /**
   * Specify your own class name into this prop, if you need to customise layout of this component.
   * This class name will be put into the parent container.
   */
  className: PropTypes.string,

  /**
   * When true adds class btn-link--reverse, which puts the icon on the right: needs to be used in conjunction with type="link" prop and `icon` prop
   */
  iconRight: PropTypes.bool,

  /**
   * The aria-expanded attribute provides information about whether an element is in an expanded or collapsed state.
   */
  'aria-expanded': PropTypes.bool,
  // eslint-disable-line react/require-default-props

  /**
   * The aria-label attribute provides information about the button's context. This value is read by screen reader technology. If used, children elements will be ignored by screen reader.
   */
  'aria-label': PropTypes.string
} : void 0;
var Button$1 = tracked.default(Button);

exports.Button = Button;
exports.default = Button$1;
